import { useState } from 'react';
import { partnerResults } from '../utils/constants';
import { generateEmailHtml } from '../utils/emailTemplate';

const EmailPreview = () => {
  const [lng, setLng] = useState('es');
  const result = partnerResults.A; // Usamos el patrón A como ejemplo
  const dummyAnswers = ['A', 'B', 'C', 'A', 'B', 'A', 'B', 'C'];
  const emailHtml = generateEmailHtml(
    result,
    'Usuario de Prueba',
    dummyAnswers,
    lng
  );

  return (
    <div
      style={{
        padding: '20px',
        backgroundColor: '#f0f0f0',
        minHeight: '100vh'
      }}
    >
      <div style={{ marginBottom: '20px', textAlign: 'center' }}>
        <h1 style={{ color: '#333' }}>Previsualización del Email</h1>
        <div
          style={{
            margin: '10px 0',
            display: 'flex',
            gap: '10px',
            justifyContent: 'center'
          }}
        >
          <button
            onClick={() => setLng('es')}
            style={{
              padding: '5px 10px',
              fontWeight: lng === 'es' ? 'bold' : 'normal'
            }}
          >
            ES
          </button>
          <button
            onClick={() => setLng('pt')}
            style={{
              padding: '5px 10px',
              fontWeight: lng === 'pt' ? 'bold' : 'normal'
            }}
          >
            PT
          </button>
          <button
            onClick={() => setLng('en')}
            style={{
              padding: '5px 10px',
              fontWeight: lng === 'en' ? 'bold' : 'normal'
            }}
          >
            EN
          </button>
        </div>
        <p>Este es el aspecto que tendrá el correo enviado a los usuarios.</p>
      </div>
      <div
        style={{
          backgroundColor: '#fff',
          margin: '0 auto',
          maxWidth: '800px',
          border: '1px solid #ccc',
          borderRadius: '8px',
          overflow: 'hidden'
        }}
        dangerouslySetInnerHTML={{ __html: emailHtml }}
      />
    </div>
  );
};

export default EmailPreview;
